export default "__VITE_ASSET__Ykmiqz_H__"